import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage, setSelectedPackageBlockId, createWorkOrder, setServiceMessageID, report, setTechnicianPage } from '../MovingBlockSlice';
import SalePackages from '../../SalePackagesBlock/SalePackages';

const PackagesPage = (props) => {


  useEffect(() => {
    props.report({
      actionType: 'Fiber Offer',
      status: 'Ongoing',
      messageText: 'Fiber Offer Displayed',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
    });
  }, []);


  function onSelectedPackages(data) {

    props.report({
      actionType: 'Fiber Offer',
      status: 'Ongoing',
      messageText: 'Fiber Offer Clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
    });
    props.setSelectedPackageBlockId(data.blockID)

    props.setTechnicianPage();
  }

  function clickChooseOtherPackages() {
    props.createWorkOrder({ code: "MOV2", reason: "סיבה 15 - הוצע שידרוג לסיבים 1G ומעוניין בחבילות אחרות", stepDescription: "מסך בחירת חבילות", memoID: "3" });
    props.report({
      actionType: 'Fiber Offer',
      status: 'Ongoing',
      messageText: 'To other offers link clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
      param10: "MOV2"
    });
    props.setServiceMessageID('OTHER_PACKAGES');
    props.goToPage("serviceMessagesPage");
    return;
  }


  function clickContinueCurrentPackage() {
    props.createWorkOrder({ code: "MOV2", reason: "סיבה 14 - הוצע שידרוג לסיבים 1G ולא מעוניין", stepDescription: "מסך בחירת חבילות", memoID: "4" });
    props.report({
      actionType: 'Fiber Offer',
      status: 'Ongoing',
      messageText: 'Not intrested button clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
      param10: "MOV2"
    });
    props.setServiceMessageID('TECHNICIAN_MOMENT');
    props.goToPage("serviceMessagesPage");
    return;
  }

  return (
    <>
      {/* <ProgressLine percent={props.percent} /> */}
      <div className='packages-page'>
        <div className='packages-title-container'>
          <h1 className='title-black'>
            <span dangerouslySetInnerHTML={{ __html: props.packagesTitle }}></span>
          </h1>
        </div>
        <div className='packages-title-bonus'>
          <span dangerouslySetInnerHTML={{ __html: props.packagesSubTitle }}></span>
        </div>
      </div>

      <SalePackages packages={props.packages} onSelectedPackages={onSelectedPackages} />

      <div className='packages-box-moreDetails'>
        <button onClick={() => { clickChooseOtherPackages() }}>להצעות Fiber נוספות במהירויות נמוכות</button>
      </div>

      <div className='packages-box-nextBtn'>
        <button onClick={() => clickContinueCurrentPackage()}>מעוניין להישאר בהצעה קיימת</button>
      </div>

    </>
  );
};
const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    movingEpiData: state.movingBlock.movingEpiData,
    packages: state.movingBlock.movingApartmentData.packagesList,
    packagesTitle: state.movingBlock.movingEpiData.packagesTitle?.value,
    packagesSubTitle: state.movingBlock.movingEpiData.packagesSubTitle?.value,
    products: state.movingBlock.movingApartmentData.products,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    fullAddress: state.movingBlock.movingApartmentData.address.fullAddress,
  };
};

const mapDispatchToProps = { goToPage, setSelectedPackageBlockId, createWorkOrder, setServiceMessageID, report, setTechnicianPage };

export default connect(mapStateToProps, mapDispatchToProps)(PackagesPage);
